import { render, staticRenderFns } from "./detalhesItem.vue?vue&type=template&id=473292f7"
import script from "./detalhesItem.ts?vue&type=script&lang=js&external"
export * from "./detalhesItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473292f7')) {
      api.createRecord('473292f7', component.options)
    } else {
      api.reload('473292f7', component.options)
    }
    module.hot.accept("./detalhesItem.vue?vue&type=template&id=473292f7", function () {
      api.rerender('473292f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacao/detalhesItem.vue"
export default component.exports